import * as CryptoJS from 'crypto-js';
import {environment} from "../environments/environment.development";

export class CryptographyService {

    static encryptionKey = CryptoJS.enc.Utf8.parse(environment.encryption.key); // Ensure this is 32 bytes for AES-256
    static iv = CryptoJS.enc.Utf8.parse(environment.encryption.iv); // Ensure this is 16 bytes for AES

    constructor() { }

    static encrypt(plainText) {
        const key = this.encryptionKey;
        let iv = this.iv;
        // Encrypt the plaintext
        let cipherText = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plainText), key, {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return cipherText.toString();
    }

    static decrypt(encryptedText) {
        const decrypted = CryptoJS.AES.decrypt(encryptedText, this.encryptionKey, {
            iv: this.iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        return decrypted.toString(CryptoJS.enc.Utf8);
    }
}
